<script>
import { useAlert } from 'dashboard/composables';
import WppConnectAPI from 'dashboard/routes/dashboard/settings/inbox/channels/WppConnectAPI';
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      inviteLink: '',
    };
  },
  methods: {
    async joinGroup() {
      if (!this.inviteLink) useAlert('Necessário informar link de convite');
      this.$emit('onSubmit');
      const { data } = await WppConnectAPI.newGroup(this.inbox.phone_number, {
        operation: 'join',
        inviteLink: this.inviteLink,
      });
      if (!data || !data.result.message.includes('successfully')) {
        useAlert('Ocorreu algum problema ao entrar no grupo');
        return;
      }
      this.$emit('success');
      useAlert('Successo ao entrar no grupo');
    },
  },
};
</script>

<template>
  <div class="join-group-container">
    <form class="row" @submit.prevent="joinGroup">
      <input v-model="inviteLink" type="text" placeholder="Link de Convite" />
      <div class="modal-footer medium-12 columns">
        <div class="medium-12 columns">
          <woot-submit-button
            :disabled="!inviteLink || isLoading"
            button-text="Entrar no grupo"
            :loading="isLoading"
            button-class="expanded"
            class="m-0"
          />
        </div>
      </div>
    </form>
  </div>
</template>
